import { serverRootUrl } from '@/api/api';

/**
 * Transform backend relative paths (e.g. /static/...) to absolute URLs.
 * Pass-through for already absolute URLs (Azure SAS), base64, or bundled imports.
 */
export const getFullImageUrl = (path: string | null | undefined): string | undefined => {
  if (!path) return undefined;

  // 1. Base64 data URIs
  if (path.startsWith('data:')) {
    return path;
  }

  // 2. Bundled assets (Vite) - leave as-is
  if (path.startsWith('/src') || path.startsWith('/assets')) {
    return path;
  }

  // 3. Absolute URLs (Azure Blob Storage, External Providers) - case-insensitive http/https
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  // 4. Backend static files (Legacy/Fallback)
  if (path.startsWith('/')) {
    return `${serverRootUrl}${path}`;
  }

  // 5. Fallback for unexpected relative paths without leading slash
  return path;
};

/**
 * Resolves a media path (audio/video URL) to a playable absolute URL.
 *
 * Pass-through for already absolute URLs (http/https Azure SAS, blob: from
 * URL.createObjectURL, data: base64 blobs). For bare backend paths (e.g. a
 * stored blob name) prepends the API server root.
 *
 * @param path Media URL or backend-relative path.
 * @returns Absolute URL safe to hand to <audio>, <video>, WaveSurfer, fetch.
 */
export const toAbsoluteMediaUrl = (path: string): string => {
  if (/^(https?:|blob:|data:)/i.test(path)) return path;
  return `${serverRootUrl}${path}`;
};
